import { format } from "date-fns";
import { da } from "date-fns/locale";
import { useNotifications } from "./NotificationProvider";
import { Button } from "@/components/ui/button";
import { ScrollArea } from "@/components/ui/scroll-area";
import { cn } from "@/lib/utils";

export const NotificationList = () => {
  const { notifications, markAsRead, markAllAsRead } = useNotifications();

  if (notifications.length === 0) {
    return (
      <div className="p-6 text-center text-sm text-muted-foreground">
        Ingen notifikationer
      </div>
    );
  }

  return (
    <div>
      <div className="flex items-center justify-between p-2 border-b">
        <h4 className="text-sm font-medium">Notifikationer</h4>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => markAllAsRead()}
          className="text-xs"
        >
          Marker alle som læst
        </Button>
      </div>
      <ScrollArea className="h-[300px]">
        <div className="divide-y">
          {notifications.map((notification) => (
            <div
              key={notification.id}
              className={cn(
                "p-4 hover:bg-muted/50 transition-colors",
                !notification.read && "bg-muted/20"
              )}
              onClick={() => markAsRead(notification.id)}
              role="button"
              tabIndex={0}
            >
              <div className="flex justify-between items-start mb-1">
                <h5 className="text-sm font-medium">{notification.title}</h5>
                <span className="text-xs text-muted-foreground">
                  {format(new Date(notification.created_at), "d. MMM HH:mm", {
                    locale: da,
                  })}
                </span>
              </div>
              <p className="text-sm text-muted-foreground">
                {notification.message}
              </p>
            </div>
          ))}
        </div>
      </ScrollArea>
    </div>
  );
};